// @flow
import React from 'react';

import { INSURER_TYPE } from '../../constants/home';

export const ScriptContent1 = (insurer: { insurer: string }) => (
  <div key="agent_home_viewQuote_script_1">
    {insurer?.insurer === INSURER_TYPE.FBD ? (
      <p>
        This home insurance policy is underwritten by FBD Insurance PLC who is
        regulated by the Central Bank of Ireland. You may terminate your FBD
        Home Insurance Policy at any time during the policy period. Once the
        cancellation is completed a refund of the unused portion of the Premium
        will be made to you.
      </p>
    ) : (
      <p>
        This home insurance policy is underwritten by Intact Insurance Ireland DAC trading as Intact Insurance who is
        regulated by the Central Bank of Ireland There is a 14 day cooling off period, during which time you can cancel
        the policy from commencement date and get a full refund of premiums paid assuming no claim has been paid. You
        may also cancel your policy at any time during the year or at renewal however charges may apply.
      </p>
    )}
  </div>
);

export const InsurSmartScriptContent = () => (
  <div key="insur_smart_script_content">
    <p>
      {`By continuing you are agreeing to the "InsurSmart" Terms and Conditions, which are available on the Bank of
      Ireland website and attached to your quote.
      These include agreeing that Bank of Ireland may disclose information relating to the commencement of your mortgage
      to Bank of Ireland Insurance Services Limited.`}
    </p>

    <p>
      Please review the details entered on the quote provided and contact us immediately should you require any
      amendments.
      Any errors or omissions may result in your insurance contract being cancelled, no claim being paid and you may
      experience problems with your insurance cover or any future claims.
      You may also be breaking the terms of any relevant loan.
    </p>

    <p>
      As paying by Direct Debit you need to confirm the following:
      <ul>
        <li>Can you confirm the bank account you provided requires only one signature and it accepts Direct Debits?
          (Such as a current account)
        </li>
        <li>By paying by monthly Direct Debit you are agreeing to keep up payments and failure to meet the monthly
          Direct Debit may result in your home insurance policy being cancelled and any claims not being paid. You may
          also be breaking the terms of any relevant loan.
        </li>
      </ul>
    </p>
  </div>
);

export const ScriptContent2 = () => (
  <div key="agent_home_viewQuote_script_2">
    <p>Discuss all optional extras and benefits on all calls</p>
    <ul>
      <li>Specified and unspecified items</li>
      <li>No Claims Bonus Protection (If applicable)</li>
      <li>Accidental Damage on contents (If applicable)</li>
    </ul>
  </div>
);

export const ScriptContent3 = () => (
  <div key="agent_home_viewQuote_script_3">
    <p>Please confirm details below on all calls</p>
    <ul>
      <li>Excess’s must be discussed if a quote is generated</li>
      <li>
        Our standard policy excess is €500 and water damage is €850 subsidence
        is €1000 however our excess ranges from €250-€1000 . Excess is a fixed
        amount you have to pay if you make a claim on your policy. Would you
        like me to go through these options with you or are you happy with our
        standard excess?
      </li>
      <li>
        Quote is valid for 90 days email must be kept as evidence of price and
        valid once no amendments are made
      </li>
      <li>Premium is Inclusive of Government Levy.</li>
      <li>Annual premium is XX and there is no charge for DD</li>
    </ul>
  </div>
);
